module.exports = __webpack_public_path__ + "img/2013.937512ae.png";